<template>
    <v-layout column justify-center align-center py-4>
      <v-card class="login-wrap pa-4 mb-5">
        <v-alert
          color="error"
          class="err"
          icon="warning"
          value="true"
          v-if="err">
          <v-layout column>
            <p class="mb-2">{{err}}</p>
            <div v-if="err.includes('Not found with userName')">
              <v-btn
                class="mx-0"
                @click.stop.prevent="$router.push({ name: 'registration', query: { email } })">
                {{this.$lang.actions.register}}?
              </v-btn>
            </div>
          </v-layout>
        </v-alert>
        <v-form @submit.native.prevent="submit()">
          <v-text-field
            :label="$lang.labels.email"
            v-model="email"
            name="email"
            :rules="emailRules"
            required
          ></v-text-field>
          <v-text-field
            :label="$lang.labels.password"
            v-model="password"
            name="password"
            type="password"
            :rules="passwordRules"
            required
          ></v-text-field>
          <v-layout row wrap justify-space-between class="text-xs-right">
            <v-btn
                :disabled="loginProcessStarted"
                color="primary"
                type="submit"
                class="ma-0">{{$lang.header.login}}</v-btn>
            <v-btn
              id="forgotPassword"
              flat
              @click.stop.prevent="$router.push({ name: 'forgotPassword' })"
              class="ma-0">{{$lang.actions.forgotPassword}}?</v-btn>
          </v-layout>
        </v-form>
      </v-card>
    </v-layout>
</template>

<script>
  import { mapGetters } from 'vuex';
  import auth from '../../auth';

  export default {
    data() {
      return {
        loginProcessStarted: false,
        email: '',
        password: '',
        passwordRules: [
          v => !!v || this.$lang.errors.requiredPassword,
          v => (v && v.length >= 6 && v.length <= 35) || this.$lang.errors.passwordConditions,
        ],
        emailRules: [
          v => !!v || this.$lang.errors.requiredEmail,
          // eslint-disable-next-line
          v => (v && /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v.toLowerCase())) || this.$lang.errors.notValidEmail,
        ],
        err: '',
      };
    },
    computed: mapGetters({
      company: 'company',
      companyActive: 'companyActive',
    }),
    methods: {
      submit() {
        this.loginProcessStarted = true;
        this.err = '';
        if (!this.email || !this.password) {
          this.err = this.$lang.errors.enterCredentials;
          this.loginProcessStarted = false;
          return;
        }
        this.email = this.email.trim();
        auth.login(this, { userName: this.email, password: this.password })
          .then((res) => {
            if (!res || !res.success) {
              // eslint-disable-next-line max-len
              this.err = res && res.body ? res.body.statusText || this.$lang.errors.failedLogin : this.$lang.errors.failedLogin;
              this.loginProcessStarted = false;
              return null;
            }
            this.loginProcessStarted = false;
            if (auth.isAdmin()) {
              this.$router.push({ name: 'webShop' });
              return null;
            }
            return this.$webHelper.get('contact/fetchforauser', null, this.$router);
          })
          .then((res) => {
            if (res === null) return;
            if (!res.success) {
              this.err = this.$lang.errors.failedContactInfo;
              this.loginProcessStarted = false;
              return;
            }
            this.$store.dispatch('setUserData', undefined);
            this.$store.dispatch('setAddresses', res.body.contact.address);
            this.$store.dispatch('setContact', {
              lastName: res.body.contact.lastName,
              phone: res.body.contact.phone,
            });
            const data = {
              first: res.body.contact.lastName.split(' ')[0] || '',
              last: res.body.contact.lastName.split(' ')[1] || '',
              email: res.body.contact.email || '',
              phone: res.body.contact.phone || '',
            };
            localStorage.customerData = JSON.stringify(data);
            window.Intercom('shutdown');
            this.$store.dispatch('setIntercomUser', {
              lastName: res.body.contact.lastName,
              email: res.body.contact.email,
            });
            this.loginProcessStarted = false;
            this.$router.push({ name: 'webShop' });
          });
      },
    },
    created() {
      if (this.$route.query['session-expired']) {
        this.err = this.$lang.errors.sessionExpired;
      }
    },
  };
</script>

<style lang="scss" scoped>
  .login-wrap {
    min-width: 300px;
    width: 100%;
    max-width: 480px;
  }
</style>



// WEBPACK FOOTER //
// src/components/webshop/Login.vue